import React, { useContext, useRef, useState } from "react";
import Footer from "../components/Footer";
import { getDatabase, ref, set } from "firebase/database";
import { sendEmailVerification } from "firebase/auth";
import { getStorage, uploadBytesResumable, getDownloadURL, ref as refStorage } from 'firebase/storage'
import MailchimpSubscribe from "react-mailchimp-subscribe"

import { AuthContext } from "../context/UserContext";
// import SimpleHeader from "../components/SimpleHeader";
import HeroBackgroundImage from "../images/hero.jpg";
import app from '../firebase/firebase.config';

import jsonList from '../it.json'
import ResponsiveHeader from "../components/ResponsiveHeader";
import MobileMenu from "../components/MobileMenu";

interface RegisterProps {
  status_mail: any,
  message: any,
  onValidated: Function
}

const Register:React.FC<RegisterProps> = ({ status_mail, message, onValidated }) => {
  const { createUser, logOut } = useContext(AuthContext);
  const [policyMessage, setPolicyMessage] = useState(false);
  const [errMessage, setErrMessage] = useState(false);
  const [genderMessage, setGenderMessage] = useState(false);
  const [registrationDone, setRegistraionDone] = useState(false); 
  const [portfolio, setPortfolio] = useState('')
  const [selectedFile, setSelectedFile] = useState<any>();
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("Italia");
  const [selectedCompanyCountry, setSelectedCompanyCountry] = useState("Italia");
  const [fiscalCode, setFiscalCode] = useState('');
  const [isValidFiscalCode, setIsValidFiscalCode] = useState(true);
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [isValidDateOfBirth, setIsValidDateOfBirth] = useState(true);
  const [duplicateEmail, setDuplicateEmail] = useState(false);
  const [shortPasswordLength, setShortPasswordLength] = useState(false)
  const [matchPassword, setMatchPassword] = useState(true);

  const refPortfolio = useRef<any>();
  const refGender = useRef<any>();


  const fiscalCodeRegExp = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
  const refCPassword = useRef<any>(null);
  const refPassword = useRef<any>(null);

  const handleSelectPortfolio = () => {
    refPortfolio.current.click()
  }

  const handleFileChange = (e:any) => {
    const selectedFile = e.target.files[0];
    setSelectedFile(selectedFile);
    setPortfolio(URL.createObjectURL(selectedFile));
  }

  const handleFiscalCodeChange = (e:any) => {
    const inputFiscalCode = e.target.value;
    const isValid = fiscalCodeRegExp.test(inputFiscalCode);
    setIsValidFiscalCode(isValid);
    setFiscalCode(inputFiscalCode);
  };

  const handleDateChange = (e:any) => {
    let inputDate = e.target.value;

    // Remove non-numeric characters from input
    inputDate = inputDate.replace(/[^0-9]/g, '');

    // Add "/" after the 2nd and 4th character
    if (inputDate.length > 2) {
      inputDate = inputDate.slice(0, 2) + '/' + inputDate.slice(2);
    }
    if (inputDate.length > 5) {
      inputDate = inputDate.slice(0, 5) + '/' + inputDate.slice(5);
    }

    if (inputDate.length > 10) {
      inputDate = inputDate.slice(0, 10);
    }
    // Validate the date format
    const dateRegExp = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    const isValid = dateRegExp.test(inputDate);

    // Update state and validity
    setIsValidDateOfBirth(isValid);
    setDateOfBirth(inputDate);
  };

  const handleSelectCountry = (e:any) => {
    setSelectedCountry(e.target.value);
  }

  const handleSelectCompanyCountry = (e:any) => {
    setSelectedCompanyCountry(e.target.value);
  }

  const handleChangePolicyCheck = (e:any) => {
    if (e.target.value) {
      setPolicyMessage(false)
    }
  }

  const onClickHandler = () => {
    setRegistraionDone(false);
    setPolicyMessage(false);
  }

  const subscribeToNewsletter = (email:string, name:string, surname:string) => {
    fetch(
      "https://aquamarine-halva-e2e241.netlify.app/api/subscribe-user",
      {
        method: "OPTIONS",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "email": email,
          "name": name,
          "surName": surname,
          "newsletter": "Newsletter",
          "subscriber": "Subscriber"
        }),
      }
    ).then(()=>{
      fetch(
        "https://hlg-server.vercel.app/mailtrap/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "email": email,
            "name": name,
            "surname": surname,
            "manager_link": "https://italyhlg.it/super-manager"
          })
        }
      ).catch((err)=>{
        console.error('err here!', err);
      })
    }).catch((error)=>{
      console.error('error!!!', error);
    })
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const form = e.target;
    console.log(form["password"].value)
    if (form["password"].value.length<6) {
      setShortPasswordLength(true)
      refPassword?.current.focus()
      return;
    }
    setShortPasswordLength(false)
    if (form["password"].value!=form["cpassword"].value) {
      setMatchPassword(false);
      refCPassword?.current.focus();
      return;
    }
    setMatchPassword(true);
    if (!form["policy_agree"].checked) {
      setPolicyMessage(true);
      return;
    }

    if (form["gender"].value == "Sesso") {
      setGenderMessage(true);
      document.getElementById("gender")?.focus();
    }
    let portfolioUrl="";
    try {
      const storage = getStorage(app);
      const storageRef = refStorage(storage, `/portfolios/${selectedFile?.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);
      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            console.error(snapshot);
          },
          (err) => {
            console.error(err);
            reject(err);
          },
          async () => {
            try {
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              console.error(url);
              portfolioUrl = url;
              resolve(true);
            } catch (error) {
              reject(error);
            }
          }
        );
      });
    } catch (error) {
      console.error("Error uploading portfolio:", error);
    }
    
    // get the current Date
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${month}-${day}-${year}`;
    const email = form["email"].value;
    const password = form["password"].value;
    const postData = {
      name: form["name"].value,
      surname: form["surname"].value,
      email,
      telephone: form["telephone"].value,
      linkedin: form["linkedin"].value,
      address: form["address"].value,
      cap: form["cap"].value,
      city: form["city"].value,
      province: form["province"].value,
      nation: form["nation"].value,
      tax_id: form["tax_id"].value,
      gender: form["gender"].value,
      city_of_birth: form["city_of_birth"].value,
      date_of_birth: form["date_of_birth"].value,
      agency: form["agency"].value,
      role: form["role"].value,
      company_postcode: form["company_postcode"].value,
      company_address: form["company_address"].value,
      company_city: form["company_city"].value,
      company_province: form["company_province"].value,
      company_nation: form["company_nation"].value,
      createdAt: currentDate,
      portfolio: portfolioUrl ?? '',
      company_logo_agree: form["company_logo_agree"].checked,
      verified: false,
    }

    // the Firebase Auth account is created immediately: the password is
    // hashed and stored by Firebase Auth itself, and never touches the
    // Realtime Database.
    let user: any;
    try {
      const result: any = await createUser(email, password);
      user = result.user;
    } catch (error: any) {
      if (error?.code === 'auth/email-already-in-use') {
        setDuplicateEmail(true);
      } else {
        console.error(error);
        setErrMessage(true);
      }
      return;
    }

    const db = getDatabase();
    try {
      await set(ref(db, `users/${user.uid}`), postData);
    } catch (error) {
      console.error("setdata", error);
      setErrMessage(true);
      return;
    }

    sendEmailVerification(user).catch((error)=>{
      console.error(error);
    })
    subscribeToNewsletter(email, postData.name, postData.surname);

    setRegistraionDone(true);
    form.reset();
    window.scrollTo(0,0);
  };
  
  const cityList = jsonList.cityList;
  const provinceList = jsonList.provinceList;
  const countryList = jsonList.countryList;

  return (
    <>
      {/* <section
        id="hero"
        className="bg-hero brightness-100 bg-no-repeat w-full bg-center bg-cover pt-80 pb-6 h-[40vh]"
      >
      </section>
      <SimpleHeader/> */}
      <ResponsiveHeader backgroundImage={HeroBackgroundImage} title="Registrazione" />
      <section>
        <div className="pb-[80px] md:pb-[200px]">
          <div className="grid grid-cols-1 md:grid-cols-5">
            <div className="hidden md:block col-span-2 pt-[100px] pl-[60px] md:pr-[20px] lg:pr-[60px]">
              <hr className="color-[#00a695] border border-[#00a695] w-4/5" />
              <div className="mt-[20px]">
                <strong>Hai bisogno di aiuto?</strong>
              </div>
              <a className="text-[#00a695]" href="">
                info@italyhlg.it
              </a>
              <p className="mt-[40px]">
                L 'iscrizione a Italy HLG permette di usufruire di:
              </p>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  Ampie possibilità di Network con <strong>altri professionisti del
                  licensing e del business development</strong> di aziende e
                  organizzazioni nel settore Healthcare.
                  <strong>
                    altri professionisti del licensing e del business
                    development
                  </strong>
                  di aziende e organizzazioni nel settore Healthcare.
                </li>
                <li>
                  <strong>Accesso alla sezione riservata </strong>del sito.
                </li>
                <li>
                  Offre{" "}
                  <strong>partecipazione ad eventi di alta formazione </strong>
                  (BD Academy), godendo di condizioni economiche di favore
                  riservate agli associati.
                </li>
                <li>
                  Partecipazione ad altre
                  <strong> iniziative culturali e ricreative </strong>organizzate
                  dall'associazione con la finalità di
                  <strong> sviluppare il network.</strong>
                </li>
                <li>
                  Partecipazione ad{" "}
                  <strong>
                    eventi organizzati da IPLS International Partnering in
                    Lifescience Society e dalle altre associate EU.
                  </strong>
                </li>
                <li>
                  <strong>
                     Accesso alla Community Platform di IPLS, con inserimento di nominativo e profilo.
                  </strong>
                </li>
              </ul>
              <div className="mt-8">
                <a
                  className="text-[#125190] text-lg font-[700] underline"
                  href=""
                >
                  Per i nuovi iscritti
                </a>
              </div>
              <ul className="mt-[20px] pl-[40px] list-disc gap-[10px]">
                <li>
                  <strong>È necessario completare il form </strong>nei suoi campi obbligatori, ed una volta confermata via mail la richiesta, procedere al versamento della 
                  <strong> quota associativa </strong> (<span className="underline">€ 300</span> socio ordinario, <span className="underline">€ 0</span> socio onorario, <span className="underline">€ 200</span> 3° e 4° rappresentante di una stessa azienda, <span className="underline font-bold">€ 150</span> dal 4° rappresentante di una stessa azienda) tramite bonifico bancario o assegno non trasferibile alle seguenti coordinate:
                </li>
                <li>Italy HLG - Healthcare Licensing Group</li>
                <li>UniCredit Banca - Agenzia Milano Buonarroti</li>
                <li>Via Michelangelo Buonarroti 19 - 20149 Milano</li>
                <li>Codice IBAN IT 47 N 02008 01767 000100480153</li>
                <li>
                  Causale: Quota associativa 2025 + Nome Associato + Nome
                  Azienda
                </li>
              </ul>
              <h1 className="text-[17px] font-bold mt-6">
                L'iscrizione del nuovo associato diventa effettiva dopo
                l'approvazione da parte del consiglio direttivo.
              </h1>
              <div className="text-[17px] mt-6">
                Se preferisci fare la richiesta di iscrizione tradizionale, compila il  <a className="underline text-[#00a695]" href="/assets/domanda-iscrizione-2026.pdf" download="domanda-iscrizione-2026.pdf">modulo di iscrizione</a>
              </div>
            </div>

            <div id="" className="col-span-3 z-10 mt-[-120px]">
              <div id="form" className="z-50 bg-white md:p-24 pt-12 px-16">
                <div className="hidden md:block text-5xl text-[#0c2957] font-[700]">
                  <h1 className="mb-6">Iscrizione e</h1>
                  <h1>registrazione</h1>
                </div>
                <p className="md:mt-6 font-bold md:font-[600]">
                  Unisciti alla community dei professionisti del licensing e del business development  del settore healthcare. Fare network. Un'opportunità per gli specialisti del Business Development.
                </p>
                <a id="GoToForm" href="#form"></a>
                <a id="GoToGender" href="#gender"></a>
                {
                  registrationDone ?
                  <div className="bg-[#e0f9fd] p-6 mt-6">
                    Grazie di esserti registrato! Ti abbiamo inviato una mail per confermare il tuo indirizzo. Il nostro team sta valutando la tua iscrizione per garantirti l'accesso.&nbsp;
                    <span className="underline text-[#15818d] cursor-pointer" onClick={onClickHandler}>Invia di nuovo</span>
                  </div>
                  :
                      <form className="mt-6 w-full md:w-[80%]" onSubmit={handleSubmit}>
                      {errMessage && (
                        <h1 className="text-red-600 font-bold">
                          Registrazione non riuscita. Controlla che l'e-mail sia già
                          presente registrato o i dati non sono nuovamente corretti.
                        </h1>
                      )}
                      <input
                        id="name"
                        name="name"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        defaultValue=""
                        placeholder="Name"
                        required
                      />
                      <input
                        id="surname"
                        name="surname"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Cognome"
                        required
                      />
                      <input
                        id="email"
                        name="email"
                        className="block w-full p-5 my-4 border border-1"
                        type="email"
                        placeholder="E-mail"
                        required
                      />
                      <input
                        ref={refPassword}
                        name="password"
                        id="password"
                        className="block w-full p-5 my-4 border border-1"
                        type="password"
                        placeholder="Password"
                        required
                      />
                      {shortPasswordLength && (
                        <div className="text-red-600 text-lg mt-2">
                          La password deve contenere almeno 6 caratteri
                        </div>
                      )}
                      <input
                        ref={refCPassword}
                        id="cpassword"
                        name="cpassword"
                        className="block w-full p-5 my-4 border border-1"
                        type="password"
                        placeholder="Ripeti password"
                        required
                      />
                      {!matchPassword && (
                        <div className="text-red-600 text-lg mt-2">
                          Attenzione! Le password devono coincidere
                        </div>
                      )
                      }
                      <input
                        id="linkedin"
                        name="linkedin"
                        className="block w-full p-5 mb-4 mt-20 border border-1"
                        type="text"
                        placeholder="Linkedin address (es: linkedin.com/in/mariorossi)"
                      />
                      
                      <label htmlFor="portfolio" className="mt-20 text-sm text-gray-400">Aggiungi la tua foto</label>
                      <img src={portfolio} className="w-[80%]" alt="" />
                      <input onChange={ handleFileChange } accept="image/*" type="file" className="hidden" ref={refPortfolio}/>
                      <button onClick={ handleSelectPortfolio } className="text-center py-4 w-[80%] text-sm mt-2 border border-1">Scegli il file da caricare</button>
                      
                      <input
                        id="telephone"
                        name="telephone"
                        className="block w-full p-5 mb-4 mt-20 border border-1"
                        type="phone"
                        placeholder="Telefono"
                        required
                      />
                      <input
                        id="address"
                        name="address"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Indirizzo"
                        required
                      />
                      <input
                        id="cap"
                        name="cap"
                        className="block w-full p-5 my-4 border border-1"
                        type="number"
                        placeholder="CAP"
                        required
                      />
                      <select                         
                        id="nation"
                        name="nation"
                        className="block w-full p-5 my-4 border border-1"
                        placeholder="Nazione"
                        value={selectedCountry}
                        onChange={handleSelectCountry}
                        required
                      >
                        {/* <option value="">Nazione</option> */}
                        {
                          countryList.map((country) => (
                            <option key={country} value={country}>{country}</option>
                          ))
                        }
                      </select>
                      <input
                        id="city"
                        name="city"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Città"
                        required
                      />
                      {
                        selectedCountry === 'Italia' ?
                        <>
                          {/* <select                         
                            id="city"
                            name="city"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Città"
                            required
                          >
                            <option value="">Città</option>
                            {
                              cityList.map((city) => (
                                <option key={city} value={city}>{city}</option>
                              ))
                            }
                          </select> */}
                          <select                         
                            id="province"
                            name="province"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Provincia"
                            required
                          >
                            <option value="">Provincia</option>
                            {
                              provinceList.map((province) => (
                                <option key={province} value={province}>{province}</option>
                              ))
                            }
                          </select>
                        </>
                        :
                        <>
                          <input
                            id="province"
                            name="province"
                            className="block w-full p-5 my-4 border border-1"
                            type="text"
                            placeholder="Provincia"
                            required
                          />
                        </>
                      }
    
                      
                      {/* <input
                        id="nation"
                        name="nation"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Nazione"
                      /> */}
    
                      <input
                        id="tax_id"
                        name="tax_id"
                        className="block w-full p-5 my-4 mt-20 border border-1"
                        type="text"
                        placeholder="Codice Fiscale"
                        onChange={handleFiscalCodeChange}
                        required
                      />
                      <select
                        ref={refGender}
                        id="gender"
                        name="gender"
                        className="block w-full p-5 my-4 border border-1"
                        required
                      >
                        <option value="sesso">Sesso</option>
                        <option value="man">Maschio</option>
                        <option value="woman">Femmina</option>
                        <option value="woman">Preferisco non dire</option>
                      </select>
                      {genderMessage && (
                        <h1 className="text-red-600">
                          Per favore seleziona il tuo genere
                        </h1>
                      )}
                      <input
                        id="city_of_birth"
                        name="city_of_birth"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Città di nascita"
                        required
                      />
                      <input
                        id="date_of_birth"
                        name="date_of_birth"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        value={dateOfBirth}
                        onChange={handleDateChange}
                        placeholder="Data di nascita"
                        required
                      />
                      {!isValidDateOfBirth && <p className="text-red-600 text-xs">Inserire una data in formato gg/mm/aaaa</p>}
                      <input
                        id="agengy"
                        name="agency"
                        type="text"
                        className="block w-full p-5 my-4 mt-20 border border-1"
                        placeholder="Azienda"
                        required
                      />
                      <input
                        id="role"
                        name="role"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Ruolo"
                        required
                      />
                      <input
                        id="company_address"
                        name="company_address"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Indirizzo Azienda"
                        required
                      />
                      <input
                        id="company_postcode"
                        name="company_postcode"
                        className="block w-full p-5 my-4 border border-1"
                        type="number"
                        placeholder="CAP Azienda"
                        required
                      />
                      <select                         
                        id="company_nation"
                        name="company_nation"
                        className="block w-full p-5 my-4 border border-1"
                        placeholder="Nazione Azienda"
                        value={selectedCompanyCountry}
                        onChange={handleSelectCompanyCountry}
                        required
                      >
                        {/* <option value="">Nazione</option> */}
                        {
                          countryList.map((country) => (
                            <option key={country} value={country}>{country}</option>
                          ))
                        }
                      </select>
                      <input
                        id="company_city"
                        name="company_city"
                        className="block w-full p-5 my-4 border border-1"
                        type="text"
                        placeholder="Città Azienda"
                        required
                      />
                      {
                        selectedCompanyCountry === 'Italia' ?
                        <>
                          {/* <select                         
                            id="company_city"
                            name="company_city"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Città Azienda"
                            required
                          >
                            <option value="">Città</option>
                            {
                              cityList.map((city) => (
                                <option key={city} value={city}>{city}</option>
                              ))
                            }
                          </select> */}
                          <select                         
                            id="company_province"
                            name="company_province"
                            className="block w-full p-5 my-4 border border-1"
                            placeholder="Provincia Azienda"
                            required
                          >
                            <option value="">Provincia</option>
                            {
                              provinceList.map((province) => (
                                <option key={province} value={province}>{province}</option>
                              ))
                            }
                          </select>
                        </>
                        :
                        <>
                          {/* <input
                            id="company_city"
                            name="company_city"
                            className="block w-full p-5 my-4 border border-1"
                            type="text"
                            placeholder="Città Azienda"
                            required
                          /> */}
                          <input
                            id="company_province"
                            name="company_province"
                            className="block w-full p-5 my-4 border border-1"
                            type="text"
                            placeholder="Provincia Azienda"
                            required
                          />
                        </>
                      }

                      <div className="mt-12 flex gap-2 text-sm">
                        <input
                          id="company_logo_agree"
                          name="company_logo_agree"
                          type="checkbox"
                          className="border-4 shadow border-gray-400 text-[24px] w-[15px] md:w-[20px] h-[20px]"
                        />
                        <div>
                          Acconsento a mostrare il logo della mia azienda sul sito web
                        </div>
                      </div>
                      <hr className="text-gray-500 mt-4" />
                      <div className="mt-4 mb-8 flex gap-2 text-sm">
                        <input
                          id="policy_agree"
                          name="policy_agree"
                          type="checkbox"
                          className="border-4 shadow border-gray-400 text-[24px] w-[15px] md:w-[20px] h-[20px]"
                          onChange={handleChangePolicyCheck}
                        />
                        <div>
                          {"   "}Accetto{" "}
                          <a className="underline" href="">
                            termini e condizioni della <a href="/privacy-policy">privacy</a>
                          </a>
                        </div>
                      </div>
                      {policyMessage && (
                        <div className="text-red-600 text-lg mt-2">
                           E' necessario accettare i termini e le condizione della <a href="/privacy-policy">privacy</a>
                        </div>
                      )}
                      {
                        duplicateEmail && (
                          <div className="text-red-600 text-lg mt-2">
                            Utente già registrato! Non è possibile completare la registrazione
                          </div>
                        )
                      }
                      <button
                        className="block w-full p-6 mt-8 mb-4 uppercase text-white text-xs bg-[#00a695]"
                        type="submit"
                      >
                        CONCLUDI LA REGISTRAZIONE
                      </button>
                      </form>
                 }
                
              </div>
            </div>
          </div>
        </div>
      </section>
      <MobileMenu/>
      <Footer/>
    </>
  );
}

const MailchimpRegister = () => {
  const url = `https://italyhlg.us22.list-manage.com/subscribe/post?u=245c1c35111c0766e4a980d04&id=5ba848767e`;

  return (
      <div className="mc__form-container">
          <MailchimpSubscribe
              url={url}
              render={({ subscribe, status, message }) => (
                  <Register
                      status_mail={status}
                      message={message}
                      onValidated={(formData:any) => subscribe(formData)}
                  />
              )}
          />
      </div>

  )
}

export default MailchimpRegister;
